/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
function callPhone(options, context) {
    context === null || context === void 0 ? void 0 : context.PanguMiniAppCall('showCallMenu', options, {
        formatInput: function (input) {
            return {
                phoneNumber: input.phoneNumber,
                code: '+86',
                showDingCall: true, // 是否显示钉钉电话
            };
        },
    });
}

export { callPhone as default };
